import './StickerMockup.css'

function StickerMockup({ imageUrl, isCustom = false }) {
  return (
    <div className="sticker-mockup-container">
      <div className={`sticker-mockup ${isCustom ? 'custom' : 'default'}`}>
        {imageUrl ? (
          <>
            <div className="sticker-circle">
              <img src={imageUrl} alt="Custom sticker design" className="sticker-image" />
              <div className="sticker-overlay"></div>
            </div>
            {isCustom && <div className="custom-design-badge">Custom Design</div>}
          </>
        ) : (
          <div className="sticker-circle default-sticker">
            <div className="default-content">Sticker Design</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StickerMockup
